var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "warning-block" }, [
    _c("i", { staticClass: "iconfont yellow" }, [_vm._v("")]),
    _c("div", { staticClass: "text" }, [
      _c("p", { staticClass: "warning-text" }, [
        _vm._v(_vm._s(_vm.$t("components.wthdraw.warning[0]"))),
      ]),
      _c(
        "p",
        { staticClass: "warning-text" },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("components.wthdraw.warning[1]")))]),
          _c("router-link", { attrs: { to: "/aq/logisticsManage" } }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("components.wthdraw.warning[2]"))),
            ]),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("components.wthdraw.warning[3]")))]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }